package navigation.settings.paymentparameter.paymentparameter

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.paymentparameter.domain.repository.PaymentParameterRepository
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase
import com.essntl.features.paymentparameter.ui.paymentparameter.PaymentParameterEvent
import com.essntl.features.paymentparameter.ui.paymentparameter.PaymentParameterState
import com.essntl.features.paymentparameter.ui.paymentparameter.PaymentParameterViewModel

class PaymentParameterScreenModel(
    paymentParameterRepository: PaymentParameterRepository,
    getCurrentUserUseCase: GetCurrentUserUseCase,
    loadingManager: LoadingManager,
) : StateScreenModel<PaymentParameterState>(PaymentParameterState()) {

    private val paymentParameterViewModel =
        PaymentParameterViewModel(
            paymentParameterRepository = paymentParameterRepository,
            getCurrentUserUseCase = getCurrentUserUseCase,
            scope = screenModelScope,
            state = mutableState,
            loadingManager = loadingManager,
        )

    fun onEvent(event: PaymentParameterEvent) = paymentParameterViewModel.onEvent(event)
}